//@flow
import React from "react"
import { updateQuery } from "./helpers"
import type { Props, SearchChangeHandler, SearchState } from "./types"

const withSearchHandler = (
  WrappedComponent: Class<React$Component<*, *>>
): Class<React$Component<*, *>> => {
  class SearchHandler extends React.Component<Props, SearchState> {
    handleChange: SearchChangeHandler

    constructor(props) {
      super(props)
      this.state = { query: props.searchName, changed: false }
      this.handleChange = this.handleChange.bind(this)
    }

    handleChange = event => {
      const { url, routerAction, handleSearch } = this.props
      const query = event.target.value

      if (handleSearch) {
        handleSearch(query)
      }

      if (url && routerAction) {
        this.setState(() => ({ query, changed: true }))
        updateQuery(url, routerAction, query, () => this.resetTextChanged())
      }
    }

    resetTextChanged = () => {
      this.setState(() => ({ changed: false }))
    }

    render() {
      return (
        <WrappedComponent
          handleSearchChange={this.handleChange}
          {...this.state}
          {...this.props}
        />
      )
    }
  }

  return SearchHandler
}

export default withSearchHandler



// WEBPACK FOOTER //
// ./src/SearchTableView/withSearchHandler.js